import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { sortBy } from 'lodash';
import { Observable } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { Settings } from '../core/settings';
import { Site } from '../sites/site';
import { SubjectsReadModel } from './subject';

@Injectable()
export class SubjectsStorage {

    public lastVisitedZcSubjectId: string;

    constructor(
        private settings: Settings,
        private http: HttpClient,
    ) {
    }

    public getSubjects(selectedSite: Observable<Site>) {
        return selectedSite
            .pipe(
                flatMap((site: Site) => this.http
                    .get(`${this.settings.apiUrl}/site/${site.siteId}/subjects`)),
                map((response) => {
                    const result = deserialize(response, SubjectsReadModel).subjects;
                    return sortBy(result, subject => subject.subjectNumber);
                }));
    }
}